import React, { useState } from 'react'
import { Redirect } from 'react-router-dom'

import { ReactComponent as LoginBg } from '../../assets/images/login-bg.svg'
import { ReactComponent as Logo } from '../../assets/images/logo.svg'

import styles from './LoginReset.module.sass'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'
import useSession from 'hooks/useSession'

const ChangePassword = () => {
	const [passwords, setPasswords] = useState({})
	const { user, activity, error, changePassword, resetState } = useSession()

	const { oldPassword, newPassword, newPasswordConfirmation } = passwords

	const handleSubmit = (e) => {
		e.preventDefault()
		changePassword(passwords)
	}

	const handleInputChange = (e) => {
		resetState(false, true, true)
		const target = e.target
		const name = e.target.name
		setPasswords((prevState) => ({
			...prevState,
			[name]: target.value,
		}))
	}

	if (!user || !user.changePasswordRequired) {
		return <Redirect to='/login' />
	} else if (user && !user.changePasswordRequired) {
		return <Redirect to='/' />
	}

	return (
		<>
			<Logo className={styles['logo']} />
			<HStack
				className={styles['main']}
				columns={[1, 1]}
				justify='stretch'
			>
				<VStack align='center' justify='space-around'>
					<Widget
						className={styles['banner']}
						paddings={['xlarge', 'large', '']}
					>
						<h1>
							Nós somos <strong>Trust!</strong>
						</h1>
						<p>
							<strong>Gestão Integrada de Saúde</strong>
						</p>
						<p>
							Terá de realizar login para continuar. Se pretende
							obter qualquer informação, por favor,{' '}
							<a href='mailto:trust@trustsaude.pt'>
								contacte-nos.
							</a>
						</p>
					</Widget>
					<LoginBg className={styles['illustration']} />
				</VStack>
				<VStack
					align='center'
					justify='center'
					className={styles['right-side']}
				>
					<div className={`${styles['form-container']}`}>
						<form onSubmit={handleSubmit} disabled={activity}>
							<h1 className={styles['has-subtitle']}>
								Mudança de password obrigatória
							</h1>
							{error && (
								<small>
									{error.message || error[0]?.message}
								</small>
							)}
							<div className={styles['text-inputs']}>
								{activity && (
									<div className={styles['message']}>
										<small>Sending info</small>
									</div>
								)}
								<TextInput
									tint='light'
									className={styles['text-input']}
									type='password'
									name='oldPassword'
									placeholder='Password antiga'
									required
									value={oldPassword}
									onChange={handleInputChange}
								/>
								<TextInput
									tint='light'
									className={styles['text-input']}
									type='password'
									name='newPassword'
									placeholder='Nova password'
									required
									value={newPassword}
									onChange={handleInputChange}
								/>
								<TextInput
									tint='light'
									className={styles['text-input']}
									type='password'
									name='newPasswordConfirmation'
									placeholder='Confirmação da nova password'
									required
									value={newPasswordConfirmation}
									onChange={handleInputChange}
								/>
							</div>
							<div className={styles['form-actions']}>
								<ActionButton
									className={styles['login-button']}
									primary
									type='submit'
								>
									Atualizar
								</ActionButton>
							</div>
						</form>
					</div>
				</VStack>
			</HStack>
		</>
	)
}

export default ChangePassword
